
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import selectIconTypePop from '@/views/store/createStore/selectIconTypePop.vue'
import { getStoreInfo } from '@/api/store'

@Component({
  components: {
    selectIconTypePop
  }
})
export default class StoreInfo extends Vue {
  // 从 Vuex 获取店铺信息 (假设 store 中有这些字段，如果没有则需要从接口获取)
  // 这里暂时模拟数据，您可以根据实际 Vuex 结构调整
  @Getter companyId!: string
  
  storeInfo = {
    storeName: '',
    companyName: '',
    storeHeadPortrait: '',
    address: '',
    receiveAddressDtl: '',
    longitude: '',
    latitude: '',
    jrAddress: ''
  }
  storeId = ''

  created() {
    this.getStoreDetail()
  }

  activated() {
      this.getStoreDetail()
  }

  async getStoreDetail() {
    try {
      const res = await getStoreInfo({ storeId: this.companyId })
      if (res.code === '000000' && res.data) {
        this.storeInfo = res.data
      }
    } catch (e) {
      console.error('获取店铺信息失败', e)
      this.$toast.fail('获取店铺信息失败')
    }
  }

  onEditStoreName() {
    this.$router.push({
        path: '/editStoreName',
        query: { name: this.storeInfo.storeName }
    })
  }

  onEditCompanyName() {
    this.$router.push({
        path: '/editCompanyName',
        query: { name: this.storeInfo.companyName }
    })
  }
  
  onEditAddress() {
      window.sessionStorage.setItem('editStoreAddressInfo', JSON.stringify({
        address: this.storeInfo.address,
        receiveAddressDtl: this.storeInfo.receiveAddressDtl,
        longitude: this.storeInfo.longitude,
        latitude: this.storeInfo.latitude,
        jrAddress: this.storeInfo.jrAddress
      }))
      this.$router.push({
        path: '/editStoreAddress',
      })
  }

  onEditStoreIcon() {
    ;(this.$refs.selectIconTypePopRef as any).showPop({ fromSource: 'storeInfo' })
  }
}
